import React, { Fragment, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import {
  Autocomplete,
  FormControl,
  TextField,
  Typography,
} from "@mui/material";
import { Card, Col, Container, Row } from "reactstrap";

import { Icon } from "@progress/kendo-react-common";
import { isArray } from "lodash";
import { useAuth } from "oidc-react";
import { useNavigate } from "react-router-dom";
import { filterAllowedColumn } from "../../_helper/helper";
import { advanceSearch } from "../../_helper/services/advanceSearchv2";
import ErrorBoundary from "../../ErrorBoundry";
import visileColumns from "./visibleColumns";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

function BenefitsAnalysis() {
  let {
    columns,
    loadingSearch,
    searchParameter,
    ColumnsSorted,
    searchResults: { results, rowCount },
  } = useSelector((state) => state.advanceSearchv2Reducer);
  const history = useNavigate();
  const { userData } = useAuth();
  const [expandedSearchResult, setexpandedSearchResult] = useState(false);
  const [page, setPage] = useState(1);
  const [additionalWhere, setAdditionalWhere] = useState("");
  const [sortData, setSortData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [chooseFilterMethod, setChooseFilterMethod] = useState("normalSearch");
  const [searchParams, setSearchParams] = useState([]);
  const [sortedColumns, setSortedColumns] = useState([]);
  const [DeparementCode, setDepartmentCode] = useState(
    userData?.profile?.DEPT_CODE ? userData.profile.DEPT_CODE[0] : ""
  );
  const listName = "Benefits_Analysis";

  useEffect(() => {
    //  let searchParam= []
    // 	if (DeparementCode) {
    // 		searchParam.push({
    // 			columnName: "DeptCode",
    // 			operator: "=",
    // 			value: DeparementCode,
    // 			dataType: "varchar(max)",
    // 			logicOperator: "AND",
    // 		});
    // 	}else{
    // 		searchParam = searchParams.filter((i) => i.columnName !== "DeptCode" )
    // 	}
    if (DeparementCode) {
      setAdditionalWhere(`Department = '${DeparementCode}'`);
    }

    // setSearchParams(searchParam);
  }, [DeparementCode]);

  const colors = [
    "#42a5f5",
    "#ba68c8",
    "#ef5350",
    "#ff9800",
    "#03a9f4",
    "#4caf50",
  ];

  const getChartDetails = (chart, type) => {
    if (type === "pie") {
      let series_name = "";
      let series_data = [];
      let empshare = [];
      let chart_title = "Benefits statistics";

      let opPie = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
        },
        title: {
          text: chart_title,
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}:{point.y}</b>",
            },
          },
        },
        series: [
          {
            name: "Employee",
            colorByPoint: true,
            data: benefitsData.map((i) => {
              return { name: i.title, y: i.total };
            }),
          },
        ],
      };
      return opPie;
    }
    if (type === "column") {
      let series_name = "";
      let series_data = [];
      let empshare = [];
      let chart_title = "Benefits statistics";

      let opPie = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "column",
        },
        title: {
          text: chart_title,
        },
        xAxis: {
          categories: benefitsData.map((i) => i.title),
          crosshair: true,
          accessibility: {
            description: "Countries",
          },
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.y}</b>",
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}:{point.y}</b>",
            },
          },
        },
        series: [
          {
            name: "Employee",
            data: benefitsData.map((i, index) => ({
              y: i.total,
              color: colors[index % colors.length], // Assign color from the colors array
            })),
          },
        ],
      };
      return opPie;
    }
  };

  const actions = useMemo(() => {
    return [
      {
        title: "Show Details",
        action: (props) => {
          return history(
            `/health-enrollment/${props.dataItem.EmployeeID}/update`,
            { state: columns }
          );
        },
        icon: { iconName: "k-icon  k-i-eye" },
        className: "font-primary",
        style: { cursor: "pointer" },
      },
    ];
  });
  useEffect(() => {
    if (loadingSearch) setexpandedSearchResult(true);
  }, [loadingSearch]);

  useEffect(() => {
    if (ColumnsSorted[listName] !== undefined) {
      setSortedColumns(ColumnsSorted[listName]);
    } else {
      if (columns && visileColumns.length > 0 && columns.length > 0) {
        const clms = visileColumns.map((d) => d.field.toLowerCase());
        const data = columns
          .filter((p) => clms.indexOf(p.column_name.toLowerCase()) < 0)
          .map((p) => {
            return {
              field: p.column_name,
              show: false,
              locked: false,
              width: 200,
              title: p.column_title,
              filter: "text",
            };
          });
        setSortedColumns(
          filterAllowedColumn(userData, visileColumns.concat(data)),
          "employeeID"
        );
      }
    }
  }, [columns]);

  const handlePageChange = (event) => {
    setPage(event.page.skip / event.page.take + 1);
    setPageSize(event.page.take);
  };
  const handleSortChange = (sort) => {
    setSortData(sort);
    setPage(1);
  };
  const handleFilterChange = (data) => {
    setAdditionalWhere(data);
    setPage(1);
  };

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
    setPage(1);
  };
  const getWhere = () => {
    // if (userData.profile.role === "user") {
    //   return `employeeID = ${userData?.profile?.EmployeeID}  ${additionalWhere ? `and ${additionalWhere}` : ``
    //     }`;
    // } else {
    return additionalWhere;
    // }
  };
  // useEffect(() => {
  //   if (searchParameter[listName]?.searchParams?.length > 0) {
  //     setSearchParams(JSON.parse(searchParameter[listName]?.searchParams));
  //   }
  // }, [searchParameter]);

  const [benefitsData, setBenefitsData] = useState([]);
  const getBenefitsData = async (userId, type = false) => {
    const payload = {
      tableName: "vw_benefit_statistics",
      searchParams: "[]",
      columns: "*",
      pageNumber: 1,
      pageSize: 10000,
      sortData: "",
      additionalWhere: "",
      location: "Benefits-global",
    };

    try {
      const response = await advanceSearch(payload, "Benefits");
      const { results, rowCount } = response;
      setBenefitsData(results);
      // setRowCount(rowCount);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    getBenefitsData();
  }, []);

  return (
    <ErrorBoundary>
      {" "}
      <Fragment>
        <Container fluid={true}>
          <Row className="bg-primary rounded py-3 mb-3">
            <Col md={6}>
              <Typography variant="h5">
                <Icon
                  style={{ fontSize: "25px", margin: "10px" }}
                  name="graph"
                />
                Benefits Analysis
              </Typography>
            </Col>
            {isArray(userData?.profile?.DEPT_CODE) ? (
              <Col md={6} className="d-flex justify-content-end">
                <FormControl
                  className="payperiodRange"
                  style={{ marginRight: "10px" }}
                >
                  <span>
                    <Autocomplete
                      size="small"
                      name="dept_Code"
                      id="payperiod_range"
                      className="muirmexpand min-w-128 text-16 "
                      style={{ margin: 0 }}
                      disableClearable={true}
                      value={DeparementCode}
                      onChange={(event, value) => {
                        setDepartmentCode(value);
                        // dispatch(setDeptCode(value))
                      }}
                      options={
                        (userData?.profile?.DEPT_CODE?.length &&
                          userData?.profile?.DEPT_CODE) ||
                        []
                      }
                      getOptionLabel={(option) => option || ""}
                      renderInput={(params) => (
                        <TextField
                          defaultValue={
                            userData?.profile?.DEPT_CODE?.length &&
                            userData?.profile?.DEPT_CODE
                              ? userData?.profile?.DEPT_CODE[0]
                              : null
                          }
                          size="small"
                          {...params}
                          margin="dense"
                          variant="outlined"
                          style={{ minWidth: "100px", marginRight: "10px" }}
                          inputProps={{
                            ...params.inputProps,
                            style: { color: "white" },
                          }}
                        />
                      )}
                    />
                  </span>
                </FormControl>
              </Col>
            ) : null}
          </Row>
          {/* <Row>
            <Col sm="12" className="page-content">
                {benefitsData && benefitsData?.map((item,index)=>{
                  return (
                    <Card sx={{mb: 1.5, width: '100%'}} key={index}>
                      <CardContent>
                        <Typography sx={{fontSize: 16}}>{item?.title}</Typography>
                        <Typography sx={{fontSize: 14}} color="text.secondary">
                          {item?.total}
                        </Typography>
                      </CardContent>
                    
                    </Card>
                  )
                 })
                }
            </Col>
          </Row> */}
          <Row>
            <Col md={6}>
              <Card className="p-3">
                <HighchartsReact
                  highcharts={Highcharts}
                  options={getChartDetails("column", "pie")}
                />
              </Card>
            </Col>
            <Col md={6}>
              <Card className="p-3">
                <HighchartsReact
                  highcharts={Highcharts}
                  options={getChartDetails("column", "column")}
                />
              </Card>
            </Col>
          </Row>
          <Row></Row>

          {/* <Row>
            <Col sm="12" className="page-content">
              <Card>
                <CardBody>
                  <AdvanceSearch
                    id={listName}
                    gridId={listName}
                    location="global"
                    columnList={"*"}
                    columnRefernces={[]}
                    tableName={userData.profile.role == "BenefitsDepartmentManagement" ? "sp_BenefitsDeptUserList" : "sp_BenefitsGovtUserList" }
                    searchParams={searchParams}
                    additionalWhere={getWhere()}
                    expanded={true}
                    sortData={sortData}
                    pageNumber={page}
                    pageSize={pageSize}
                    chooseFilterMethod={chooseFilterMethod}
                  />

                  <div>
                    {sortedColumns.length > 0 && (
                      <TelerikDataTable
                        id={listName}
                        pageSize={pageSize}
                        totalCount={rowCount}
                        skip={(page - 1) * pageSize}
                        take={pageSize}
                        data={results || []}
                        sortData={sortData}
                        onFilterChange={handleFilterChange}
                        onSortChange={handleSortChange}
                        onPageChange={handlePageChange}
                        onPageSizeChange={handlePageSizeChange}
                        selectedColumns={sortedColumns}
                        setSortedColumns={setSortedColumns}
                        loading={loadingSearch}
                        actions={actions}
                        isDashboard={true}
                        setChooseFilterMethod={setChooseFilterMethod}
                        chooseFilterMethod={chooseFilterMethod}
                      ></TelerikDataTable>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row> */}
        </Container>
      </Fragment>
    </ErrorBoundary>
  );
}
export default BenefitsAnalysis;
